import React from "react";
import { Box, Grid, TextField } from "@mui/material";

const VerticalLayout = ({ data, image, onTextFieldChange }) => {
  return (
    <Box sx={{ height: "100vh" }}>
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <TextField
            id="outlined-multiline-fixed"
            label="Sequence diagram UML"
            multiline
            value={data}
            maxRows={20}
            style={{ width: "100%" }}
            onChange={onTextFieldChange}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <img
            src={image}
            alt="Diagram"
            style={{ maxWidth: "100%", height: "100%" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VerticalLayout;
